/* istanbul ignore file */

import React from 'react'
import Head from 'next/head'
import { HeroModule } from '@pcln/marketing'
import { Box } from 'pcln-design-system'
import { SearchFormDesktop } from '@/components/SearchForm'
import useSeti from '@/hooks/useSeti'
import analytics from '@/shared-utils/analytics'
import HomeContent from './HomeContent'

const kaleyImage =
  'https://s1.pclncdn.com/design-assets/next-landing/assets/images/hero/'

const defaultHeroProps = {
  searchForms: <SearchFormDesktop />,
  backgroundImage: {
    url: `${kaleyImage}kaley-image-default.jpg?opto&auto=avif,webp`,
    altText: 'Go to your happy price'
  },
  imageClassName: 'hero-image',
  shouldDisplaySilhouette: true
}

const handleHeroImageClick = (event: Event) => {
  event.preventDefault()

  analytics.fireEvent({
    category: 'pcln_home',
    action: 'hero click'
  })

  window.open('https://www.priceline.com/vacationpackages')
}

export default function HomeDesktop() {
  const isLinkClickable = useSeti('HP_HERO_LINK') === 'VARIANT'
  const heroProps = isLinkClickable
    ? {
        ...defaultHeroProps,
        backgroundImage: {
          url: `${kaleyImage}kaley-image-variant.jpg?opto&auto=avif,webp`,
          altText: 'Go to your happy price'
        },
        handleImageClick: (event: KeyboardEvent) => {
          handleHeroImageClick(event)
        },
        ariaLabel: 'vacation packages'
      }
    : { ...defaultHeroProps }
  return (
    <>
      <Head>
        <link
          rel="preload"
          as="image"
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          fetchpriority="high" // eslint-disable-line react/no-unknown-property
          href={heroProps.backgroundImage.url}
        />
      </Head>
      <Box style={{ 'overflow-x': 'hidden' }}>
        <Box height="100%" data-testid="hero-outer-box">
          <HeroModule {...heroProps} />
        </Box>
        <HomeContent />
      </Box>
    </>
  )
}
